import * as React from 'react';
const ATTR = 'data-roving-cell';
const parse = (el) => {
    const v = el.getAttribute(ATTR);
    if (!v)
        return null;
    const [r, c] = v.split(':').map(Number);
    return Number.isFinite(r) && Number.isFinite(c) ? { r: r, c: c } : null;
};
const visible = (el) => el.getClientRects().length > 0;
function cellsOf(root) {
    if (!root)
        return [];
    const all = [...root.querySelectorAll(`[${ATTR}]`)]
        .map((el) => ({ el, p: parse(el) }))
        .filter((x) => x.p !== null);
    // Без раскладки (jsdom) видимых нет вовсе — тогда считаем видимыми все.
    const shown = all.filter((x) => visible(x.el));
    return shown.length > 0 ? shown : all;
}
/** Next cell for a key; `null` — stay. */
export function rovingTarget(cells, from, key) {
    const row = cells.filter((x) => x.r === from.r).sort((a, b) => a.c - b.c);
    const rows = [...new Set(cells.map((x) => x.r))].sort((a, b) => a - b);
    const nearestIn = (r) => {
        const inRow = cells.filter((x) => x.r === r);
        if (inRow.length === 0)
            return null;
        return inRow.reduce((best, x) => Math.abs(x.c - from.c) < Math.abs(best.c - from.c) ? x : best);
    };
    switch (key) {
        case 'ArrowRight':
            return row.find((x) => x.c > from.c) ?? null;
        case 'ArrowLeft':
            return [...row].reverse().find((x) => x.c < from.c) ?? null;
        case 'Home':
            return row[0] ?? null;
        case 'End':
            return row.at(-1) ?? null;
        case 'ArrowDown': {
            const r = rows.find((x) => x > from.r);
            return r === undefined ? null : nearestIn(r);
        }
        case 'ArrowUp': {
            const r = [...rows].reverse().find((x) => x < from.r);
            return r === undefined ? null : nearestIn(r);
        }
        default:
            return null;
    }
}
export function useRovingGrid() {
    const ref = React.useRef(null);
    const [active, setActive] = React.useState(null);
    // Активной клетки нет на экране (первый рендер, данные сменились, скрыта на
    // телефоне) — Tab-остановкой становится первая видимая.
    React.useLayoutEffect(() => {
        const cells = cellsOf(ref.current);
        if (cells.length === 0)
            return;
        if (active && cells.some((x) => x.p.r === active.r && x.p.c === active.c))
            return;
        const first = [...cells].sort((a, b) => a.p.r - b.p.r || a.p.c - b.p.c)[0];
        setActive(first.p);
    });
    const cellProps = (row, col) => ({
        tabIndex: active && active.r === row && active.c === col ? 0 : -1,
        [ATTR]: `${row}:${col}`,
        onFocus: () => {
            if (!active || active.r !== row || active.c !== col)
                setActive({ r: row, c: col });
        },
        onKeyDown: (e) => {
            const cells = cellsOf(ref.current);
            const to = rovingTarget(cells.map((x) => x.p), { r: row, c: col }, e.key);
            if (!to)
                return;
            e.preventDefault();
            setActive(to);
            cells.find((x) => x.p.r === to.r && x.p.c === to.c)?.el.focus();
        },
    });
    return { ref, cellProps };
}
//# sourceMappingURL=use-roving-grid.js.map